import React from 'react';
import { millisecondsInMinute, minutesInHour } from 'date-fns';

import { ProgramStateV2 } from '@kaltura-ott/tvpil-shared';

import { HALF_DIVIDER, LOGO_HEIGHT, SYNOPSIS_LENGTH, SYNOPSIS_VISIBLE_LENGTH } from 'consts';

import { amountResolver } from './amountResolver';

export interface priceProps {
  amount?: number;
  currency?: string;
  currencySign?: string;
}

export interface PropsImage {
  images?: any;
  size?: string;
  image?: string;
  imageParam?: string;
}

export function priceResolve(price?: priceProps, description?: string) {
  let resultPrice;

  if (Number.isFinite(price?.amount!)) {
    resultPrice = amountResolver(price?.amount!, price?.currency!);
  }

  if (resultPrice && description) {
    return (
      <>
        <b>{resultPrice}</b>
        {` / ${description}`}
      </>
    );
  }

  return <b>{resultPrice}</b> || description || '';
}

const sizeMap: { [key: string]: string } = {
  large: '16x9',
  long: '5x3',
  medium: '4x3',
  small: '2x3',
  smallest: '1x1',
};

export function sizeImageResolve({ images, size = 'large', image = '', imageParam }: PropsImage) {
  if (images) {
    if (imageParam) {
      return `${images[sizeMap[size]]?.url}${imageParam}`;
    }
    return images[sizeMap[size]]?.url;
  }
  return image ? `${image}${imageParam}` : '';
}

export function paramImageResolveParamForLandscapeByHeigh(height: number) {
  // 16x9 is ratio
  const width = (height * 16) / 9;
  return `/height/${height}/width/${Math.floor(width)}`;
}

export function paramImageResolveParamForLandscapeByWidth(width: number) {
  // 16x9 is ratio
  const height = (width * 9) / 16;
  return `/height/${Math.floor(height)}/width/${width}`;
}

export function paramImageResolveForPosterImageByWidth(width: number) {
  // 2x3 is ratio
  const height = (width * 3) / HALF_DIVIDER;
  return `/height/${Math.floor(height)}/width/${width}`;
}

export function resolveMinutesToHours(duration: number) {
  return Math.round(duration / minutesInHour);
}

export const wasInPast = (state: ProgramStateV2) => state === ProgramStateV2.PAST;

export const willInFuture = (state: ProgramStateV2) => state === ProgramStateV2.FUTURE;

export const imageUrlParam = paramImageResolveParamForLandscapeByHeigh(LOGO_HEIGHT);

export const getSynopsis = (desc: string = '') => () =>
  desc.length >= SYNOPSIS_LENGTH ? `${desc.substring(0, SYNOPSIS_VISIBLE_LENGTH)}...` : desc;

export const isFullSynopsis = (description: string = '') => () => description.length <= SYNOPSIS_LENGTH;

export const resolveMillisecondsToMinutes = (duration: number) => `${Math.round(duration / millisecondsInMinute)}m`;

export const resolveMillisecondsToHoursAndMinutes = (duration: number) => {
  const durationInMinutes = Math.round(duration / millisecondsInMinute);

  return {
    hours: Math.trunc(durationInMinutes / minutesInHour),
    minutes: durationInMinutes % minutesInHour,
  };
};

export const getAssetExpiration = (expirationTime: number | undefined) =>
  !!expirationTime && expirationTime < Date.now();
